import { redeemGiftCardLanguages, purchaseGiftCardLanguages } from "./helpers";
import { routes } from "@/global/routes";
import { vendorUUIDs } from "../../constants";
import { BAARegistrationTerms, BAACheckoutTerms } from "../../tdc_helper_baa";

const LogoImage =
  "https://ss-leagues.s3.amazonaws.com/BroadwayDallas_Logo_ComboMark_Primary_4c.png";
const BannerImage =
  "https://ss-leagues.s3.amazonaws.com/Venues/baadallas/DSM_Gift_Card_Assets_2000x2000_D.jpg";

import type { TeamConfig } from "@/global/hooks/useTeamConfig";

const config: TeamConfig = {
  teamSchema: "baa_dallas",
  browserTitle: "Dallas",
  packages: false,
  defaultRoute: routes.giftCard,
  phoneNumber: "",
  teamName: "Broadway Across America",

  // seat map configs
  seatMapConfigs: {
    venueId: "",
    mapId: "",
  },

  // gift cards
  giftCardConfigs: {
    isMenuGiftCardEnabled: false,
    isLandingPageGiftCardEnabled: false,
    isStandalonePageGiftCardEnabled: true,
    redirectGiftCardUrl: routes.giftCard,
    isCheckoutSaveCardEnabled: true,

    maxGiftPurchaseCountAllowed: 4,
  },

  // disabled routes
  disabledRoutes: [routes.purchaseSeats],

  // switches
  checkoutCreditPackages: false,
  availableCreditEnabled: false,
  isCrowdHandlerEnabled: true,
  inventoryType: "SEAT-LEVEL",

  // purchase seats config
  purchaseSeatConfigs: {
    minGameSelectionCount: 1,
    minSeatLimit: 1,
    isSimilarSeatForAllEvents: false,
    allowManualCartInSimilar: false,
    isCheckoutEditSeatsEnabled: false,
    isDiffSeatAlertEnabled: false,
    checkoutTimerEnabled: false,
    showFrontendTotalAmount: false,
    showFrontendServiceFee: false,
  },

  // feature configs
  packageConfigs: {
    isPackageEnabled: false,
    canRemovePackageGames: false,
    staticBuildYourOwn: null,
  },

  // purchase credit configs
  purchaseCreditConfigs: {
    isLandingPurchaseCreditEnabled: false,
    isStandAlonePurchaseCreditEnabled: false,
    showPurchaseCreditLinkInHomeMenu: false,
    isPurchaseCreditHistoryEnabled: false,
    checkoutTimerEnabled: false,
  },

  // intercom settings
  intercomConfigs: {
    isIntercomEnabled: true,
    allowedPages: [],
  },

  // checkout validations
  checkoutValidation: {
    allowedZipFailCount: Infinity,
    allowedPaymentFailCount: Infinity,
  },
  isSaveCardAllowed: true,

  // analytics configs
  analyticsConfigs: {
    googleAnalyticsId: "",
    attrkPixelId: "",
    beaconId: "",
  },

  // call refresh inventory when selecting games
  refreshInventoryWhenEventClick: false,

  // redirect configs
  redirectConfigs: {
    internalRedirectUrl: "",
    externalRedirectUrl: "",
  },

  // urls
  accountManagerUrl: "https://am.ticketmaster.com/baadal/",

  // vendor
  platform: vendorUUIDs.ticketmaster,

  // okta config
  oktaIssuer: "",
  oktaClientId: "",

  // images
  images: {
    findGamesBannerImage: "",
    authBackgroundImage: BannerImage,
    checkoutStatusPageImage: BannerImage,
    giftCardStandalonePageImage: BannerImage,
    logoImage: LogoImage + "?width=204&height=76",
    // 2048 × 760 pixels
    logoNameImage: "",
    faviconImage: LogoImage,
    seatMap3dPreviewImage: "",
  },

  colors: {
    primary: "#6D1823",
  },

  howItWorks: [],
  faqs: [],

  uiConfigs: {
    bannerImage: {
      title: "Choose Your Games",
      isBackgroundBasedBanner: true,
    },
    featuredGameCard: {
      showLogoWithTitle: false,
      hideOverlayLogo: false,
    },
    bottomBar: {
      showGameSelectionProgress: false,
    },
  },

  languages: {
    topNavMenuItems: "", // can be react node as well
    checkoutTermsAndCondition: <BAACheckoutTerms />,
    registrationTermsAndCondition: <BAARegistrationTerms />,
    purchaseSeats: null,
    purchaseGiftCard: purchaseGiftCardLanguages,
    redeemGiftCard: redeemGiftCardLanguages,
    giftCard: {
      title: "Give The Gift Of Broadway",
      createGiftCard: {
        description:
          "Share the magic of Broadway with a friend or loved one. Upon purchase of a gift card, a unique code will be generated for the intended recipient to redeem. Once redeemed, the recipient will receive an account credit that they can use to purchase tickets for all Broadway Dallas series shows.",
        recipient: {
          sendNowFalse: {
            description:
              "If an intended recipient is not specified, once purchased, you will have to forward the unique code to the recipient. Upon your recipient receiving their gift card, they will be prompted to enter their unique code to redeem the gift card. Once redeemed, the recipient will receive an account credit that they can use to purchase tickets for all Broadway Dallas shows.",
          },
          sendNowTrue: {
            description:
              "The Recipient will be sent an email with the unique code for them to redeem their gift card. Once redeemed, the recipient will receive an account credit that they can use to purchase tickets for all Broadway Dallas series shows.",
          },
        },
      },
      redeemGiftCard: {
        loggedIn: {
          description:
            "Please input the case sensitive code provided to redeem the value of the gift card to the Broadway Dallas account above.",
        },
        logout: {
          description:
            "Please input the case sensitive code provided to redeem the value of the gift card to the Broadway Dallas.",
        },
        success: {
          description: "has been added to your Broadway Dallas account.",
        },
      },
    },
    signInAuthText:
      "Connect your Ticketmaster account to continue with seamless access.",
  },
};

export default config;
